import { Component, OnDestroy } from "@angular/core";
import { PasswordResetService } from "../password-reset.service"; 
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    styleUrls: ["./forgot-password.component.scss"],
    standalone: false
})
export class ForgotPasswordComponent implements OnDestroy {
  step = 1;

  email = "";
  otp = "";
  newPassword = "";
  confirmPassword = "";
  resetToken = "";

  infoMsg = "";
  errorMsg = "";

  otpTimer: any;
  remainingTime = 0;

  constructor(
    private pr: PasswordResetService,
    private translate: TranslateService
  ) {}

  initiate() {
    this.errorMsg = "";
    this.infoMsg = "";

    if (!this.email) {
      this.errorMsg = "Please enter your email.";
      return;
    }

    this.pr.initiate(this.email).subscribe({
      next: (res) => {
        this.infoMsg = res.message || "OTP sent to your email.";
        this.step = 2;
        this.startOtpCountdown(180); // 3 dakika
      },
      error: (err) => {
        this.errorMsg = err.error?.error || "Failed to send OTP.";
      },
    });
  }

  
  verify() {
    this.errorMsg = "";
    this.infoMsg = "";

    if (!this.otp) {
      this.errorMsg = "Please enter the OTP.";
      return;
    }

    if (this.remainingTime <= 0) {
      this.errorMsg = "OTP expired. Please resend.";
      return;
    }

    this.pr.verify(this.email, this.otp).subscribe({
      next: (res) => {
        this.resetToken = res.reset_token;
        this.infoMsg = res.message || "OTP verified.";
        this.step = 3;
      },
      error: (err) => {
        this.errorMsg = err.error?.error || "Invalid OTP.";
      },
    });
  }

  complete() {
    this.errorMsg = "";
    this.infoMsg = "";

    if (!this.newPassword || !this.confirmPassword) {
      this.errorMsg = "Please fill in both password fields.";
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.errorMsg = "Passwords do not match.";
      return;
    }

    if (this.newPassword.length < 6) {
      this.errorMsg = "Password must be at least 6 characters long.";
      return;
    }

    this.pr.complete(this.resetToken, this.newPassword).subscribe({
      next: (res) => {
        this.infoMsg = res.message || "Password reset successful!";
        this.step = 4;

        this.newPassword = "";
        this.confirmPassword = "";
        this.resetToken = "";
      },
      error: (err) => {
        this.errorMsg = err.error?.error || "Error resetting password.";
      },
    });
  }

  resend() {
    this.errorMsg = "";
    this.infoMsg = "";

    if (!this.email) {
      this.errorMsg = "Email is missing.";
      return;
    }

    this.pr.resend(this.email).subscribe({
      next: (res) => {
        this.infoMsg = res.message || "New OTP sent to your email.";

        this.startOtpCountdown(180);

        this.errorMsg = "";
      },
      error: (err) => {
        this.errorMsg = err.error?.error || "Error resending OTP.";
      },
    });
  }

  private startOtpCountdown(seconds: number) {
    this.clearOtpCountdown();
    this.remainingTime = seconds;

    this.otpTimer = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        this.clearOtpCountdown();
      }
    }, 1000);
  }

  private clearOtpCountdown() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearOtpCountdown();
  }
}
